"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _List = require("../List");
var _expandMore = _interopRequireDefault(require("material-ui/svg-icons/navigation/expand-more"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _expandLess = _interopRequireDefault(require("material-ui/svg-icons/navigation/expand-less"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../Icon"));
require("./Accordion.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var Accordion = /*#__PURE__*/function (_React$Component) {
  _inherits(Accordion, _React$Component);
  var _super = _createSuper(Accordion);
  function Accordion(props) {
    var _this;
    _classCallCheck(this, Accordion);
    _this = _super.call(this, props);
    _this.state = {
      active: false
    };
    _this.toggleAccordion = _this.toggleAccordion.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Accordion, [{
    key: "toggleAccordion",
    value: function toggleAccordion(event) {
      event.preventDefault();
      event.stopPropagation();
      var active = this.state.active;
      this.setState({
        active: !active
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "cms-accordion"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        onClick: this.toggleAccordion,
        className: "col-sm-12 link accordion-link ".concat(this.state.active ? 'active' : '')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-12 cms-list-item link"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-8 left-item"
      }, this.props.icon ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        icon: this.props.icon,
        width: 20,
        style: {
          "float": "left",
          marginRight: 10
        }
      }) : null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "list-item-text"
      }, this.props.label, " ")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-sm-4 right-item"
      }, this.state.active ? /*#__PURE__*/_react["default"].createElement(_expandLess["default"], null) : /*#__PURE__*/_react["default"].createElement(_expandMore["default"], null)))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "accordion-container ".concat(this.state.active ? 'active' : '')
      }, this.props.children && (0, _map2["default"])(this.props.children, function (child) {
        return /*#__PURE__*/_react["default"].createElement(_List.ListItem, _extends({}, child, {
          key: child.param || child.label,
          item: child
        }));
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "clearfix"
      })));
    }
  }]);
  return Accordion;
}(_react["default"].Component);
Accordion.defaultProps = {};
Accordion.propTypes = {
  param: _propTypes["default"].string,
  label: _propTypes["default"].string,
  children: _propTypes["default"].object
};
var _default = Accordion;
exports["default"] = _default;